/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Placewebopens2Inputs */

const en_placewebopens2 = /** @type {(inputs: Placewebopens2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} opens`)
};

const de_placewebopens2 = /** @type {(inputs: Placewebopens2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} öffnet`)
};

/**
* | output |
* | --- |
* | "{day} opens" |
*
* @param {Placewebopens2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebopens2 = /** @type {((inputs: Placewebopens2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebopens2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebopens2(inputs)
	return de_placewebopens2(inputs)
});
export { placewebopens2 as "placeWebOpens" }